// extracted by mini-css-extract-plugin
export default {"root":"FloatTooltip_root__YweKO","pill":"FloatTooltip_pill__qBX1M","floatNudge":"FloatTooltip_floatNudge__K-ZTh"};